import type { ApiS3File } from '#/api/types/ApiS3File';
import type {
  ApiEmbedSearchWidgetId,
  ApiS3FileId,
} from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  s3File: ApiS3File;
};

function mapResponse(response: ApiResponse) {
  return response.s3File;
}

const endpoint = new FetchEndpoint({
  urlFactory: (
    embedSearchWidgetId: ApiEmbedSearchWidgetId,
    fileId: ApiS3FileId | null,
  ) => {
    if (!fileId) return;
    return `/data/embed-search-widgets/${embedSearchWidgetId}/files/${fileId}/meta`;
  },
  mapResponse,
});

// Exports

export const useEmbedSearchWidgetApiClientFetchS3FileMeta = endpoint.hook();
